
import logo from './img/cuhk_logo_2x.png';

import './App.css';
import {useRef,useState,useEffect,useReducer} from 'react';
import React from 'react';
import { Context, AppState, AppReducer } from './context';
import { FaCalendarAlt } from "react-icons/fa";
import { MdCancel } from "react-icons/md";

import { format } from 'date-fns';
//import { DayPicker } from 'react-day-picker';
//import 'react-day-picker/dist/style.css';

import { URL0 , blue} from './config';
import SearchText from './SearchText.js';
import { useNavigate } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import 'bootstrap/dist/css/bootstrap.min.css';
import Upload from './Upload';			

const FORM = 'cnl';
			
function Star() {
	return <span style={{color:'red'}}>*</span>	
}

function App() {
	
	
	const navigate = useNavigate();
	
	const [message,setMessage] = useState('');
	const [sysmessage,setSysmessage] = useState('');
	
	//const [generalAct,setGeneralAct] = useState([]);
	//const [init_bankname,set_init_bankname] = useState('');
	
	const [gact,setGact] = useState({act1:'',act2:''});
	const [gactmode,setGactmode] = useState('');
	
	const [banklist,setBanklist] = useState([]);
	const [position,setPosition] = useState([]);
	const [inPeriod,setInPeriod] = useState(false);
	
	const [show1,setShow1] = useState(false);	
	
	
	const addrroom = useRef();
	const addrfloor = useRef();
	const addrblock = useRef();
	const addrbldg = useRef();
	const addrest = useRef();
	const addrrd = useRef();
	const addrdist = useRef();
	const addrchi = useRef();
	const addrtel = useRef();
	const districtpoints = useRef();
					
	
	const [state,dispatch] = useReducer(AppReducer,AppState);
	const lang = state.lang;
	const eng = state.eng;
	const sc = state.sc;
	const tc = state.tc;	
	
	
	useEffect(()=>{
		if (state.msg!=''){
			console.log('xxkkkkx111');
			sysmsg(state.msg);
		}
		console.log('xxkkkkx222');
	},[state.msg]);
					
		
	const [init,setInit] = useState(false);	
	const [file, setFile] = useState();
	const [filename, setFilename] = useState();
	
	const [yearRange, setYearRange] = useState(['','','']);
	const [year, setYear] = useState('');
	const [periodTo, setPeriodTo] = useState('');
	
	const sid = useRef();
	const studentChiName = useRef();
	const studentEngName = useRef();
	
	
	const yearOfStudy = useRef();
	const tel = useRef();
	const email = useRef();
	
	const bankname = useRef();
	const bankcode = useRef();
	const bankac = useRef();
	
	//const org1 = useRef();
	//const position1 = useRef();
	//const org2 = useRef();
	//const position2 = useRef();
		
	
	const addr = useRef();
	//const addrtel = useRef();
	//const districtpoints = useRef();
		

	
	const fathername = useRef();
	const fatheraddr = useRef();
	const fathertel = useRef();
	
	
	const mothername = useRef();
	const motheraddr = useRef();
	const mothertel = useRef();
	

	const guardianname = useRef();
	const guardianrel = useRef();
	const guardiantel = useRef();
	
	
	const fmember1name = useRef();
	const fmember1rel = useRef();
	const fmember2name = useRef();
	const fmember2rel = useRef();
	const fmember3name = useRef();
	const fmember3rel = useRef();
	const fmember4name = useRef();
	const fmember4rel = useRef();
	const fmember5name = useRef();
	const fmember5rel = useRef();
	const fmember6name = useRef();
	const fmember6rel = useRef();
	const fmember7name = useRef();
	const fmember7rel = useRef();
	const fmember8name = useRef();
	const fmember8rel = useRef();
	
	
	
	const descr1a = useRef();
	const descr1b = useRef();
	const descr1c = useRef();
	const descr2a = useRef();
	const descr2b = useRef();
	const descr2c = useRef();
	const descr3a = useRef();
	const descr3b = useRef();
	const descr3c = useRef();
	
	const descrother = useRef();
	const descrremark = useRef();
	
	const wantrecord = useRef();
	const wantreason = useRef();
	
							
	const [mc,setMc] = useState({
								gender:'',
								apply1:'',									
								form:FORM,
								positionyr1:'',
								positionyr2:'',
								positionyr3:'',	
								fatherstatus:'',
								motherstatus:'',
								hostel_c:'',
								hostel_d:'',
								hostel_g:'',
								hostel_x:'',
								hostel_i:'',
								hostel_m:'',
								room_2:'',
								room_3:'',
								room_3c:'',
								health:'',
								family:'',
								declaration1:'',
								declaration2:'',
								declaration3:'',
								declaration4:'',
								want:'',
								wanthostel:'',
								
								sem:'',
								
					});					
	
	const mce = (obj) => {
		setMc({...mc,...obj});
	}
	
	const msg = (x) => {
		setMessage(x);
		setSysmessage('');
		setShow1(true);
		//console.log(x);
	}
	
	const sysmsg = (x) => {
		setMessage('');
		setSysmessage(x);		
		setShow1(true);
		//console.log(x);
	}
			
	useEffect( () => {		
		fetch(URL0 + '/post_application.php?action=resume&form=' + FORM, {
			method: 'POST',			
			headers: {
				'JWT': localStorage.getItem('jwtapplication1')
			},
		})
		.then((res) => res.text())
		.then((data) => {
			
			data = JSON.parse(data);
			console.log(data);
			
			if (data['result']){
				//setGeneralAct(data['generalAct']);
				setPosition(data['position']);
				setBanklist(data['banklist']);
				setYearRange(data['yearRange']);
				setYear(data['year']);
				setPeriodTo(data['period_to']);
				setInPeriod(data['in_period']);
				dispatch({type:'setAttachTypeLabel',value: data['attachTypeLabel'] } );
				if (data['in_period']){
					setInit(true);
				} else {
					if (data['resubmit']){						
						let warning = {'tc':'留意,只可補交文件',
										'sc':'留意,只可补交文件',
										'eng':'Notice, only submit Document is allowed'
						};
						sysmsg(warning[lang]);
						setInit(true); //俾入,睇到form,但d input field disabled 晒
						
					} else {						
						let warning = {'tc':'交申請期期限由 '+data['period_from']+' 至 '+data['period_to'],
										'sc':'交申请表期限由 '+data['period_from']+' 至 '+data['period_to'],
										'eng':'Application Period from ' +data['period_from']+' to '+data['period_to'],
						};
						sysmsg(warning[lang]);						
						setInit(false); //唔俾睇到張form 
					}
				}				
				
				if (data['filled']){					
					dispatch({type:'setUploaded',value:JSON.parse(data['filled']['attachfile'])});										
					//console.log(' dispatch ');
					setMc({
						form:FORM,
						gender:data['filled']['gender'],						
						apply1:data['filled']['apply1'],
						positionyr1:data['filled']['positionyr1'],						
						positionyr2:data['filled']['positionyr2'],						
						positionyr3:data['filled']['positionyr3'],							
						hostel_c:data['filled']['hostel_c'],
						hostel_d:data['filled']['hostel_d'],
						hostel_g:data['filled']['hostel_g'],
						hostel_x:data['filled']['hostel_x'],
						hostel_i:data['filled']['hostel_i'],
						hostel_m:data['filled']['hostel_m'],
						room_2:data['filled']['room_2'],
						room_3:data['filled']['room_3'],
						room_3c:data['filled']['room_3c'],
						health:data['filled']['health'],
						family:data['filled']['family'],
						declaration1:data['filled']['declaration1'],
						declaration2:data['filled']['declaration2'],
						declaration3:data['filled']['declaration3'],
						declaration4:data['filled']['declaration4'],
						wanthostel:data['filled']['wanthostel'],
						want:data['filled']['want'],						
						sem:data['filled']['sem'],
						fatherstatus:data['filled']['fatherstatus'],
						motherstatus:data['filled']['motherstatus'],
					});
					
					setGact({act1:data['filled']['org1_category'],act2:data['filled']['org2_category']});
					//console.log(data['filled']);
					//console.log(data['filled']);
					sid.current.value = data['filled']['sid'];
					studentChiName.current.value = data['filled']['studentChiName'];
					studentEngName.current.value = data['filled']['studentEngName'];

					
					yearOfStudy.current.value = data['filled']['yearOfStudy'];
					tel.current.value = data['filled']['tel'];
					email.current.value = data['filled']['email'];
					
					wantrecord.current.value = data['filled']['wantrecord'];
					wantreason.current.value = data['filled']['wantreason'];
					
					bankname.current.value = data['filled']['bankname'];
					//set_init_bankname(data['filled']['bankname']);
					bankcode.current.value = data['filled']['bankcode'];
					bankac.current.value = data['filled']['bankac'];

					/*org1.current.value = data['filled']['org1'];
					position1.current.value = data['filled']['position1'];
					org2.current.value = data['filled']['org2'];
					position2.current.value = data['filled']['position2'];
					addrroom.current.value = data['filled']['addrroom'];
					addrfloor.current.value = data['filled']['addrfloor'];
					addrblock.current.value = data['filled']['addrblock'];
					addrbldg.current.value = data['filled']['addrbldg'];

					*/
					
					addrroom.current.value = data['filled']['addrroom'];
					addrfloor.current.value = data['filled']['addrfloor'];
					addrblock.current.value = data['filled']['addrblock'];
					addrbldg.current.value = data['filled']['addrbldg'];
					addrest.current.value = data['filled']['addrest'];
					addrrd.current.value = data['filled']['addrrd'];
					addrdist.current.value = data['filled']['addrdist'];
					addrchi.current.value = data['filled']['addrchi'];
					
					//addr.current.value = data['filled']['addr'];
					addrtel.current.value = data['filled']['addrtel'];
					districtpoints.current.value = data['filled']['districtpoints'];

					
					fathername.current.value = data['filled']['fathername'];
					fatheraddr.current.value = data['filled']['fatheraddr'];					
					fathertel.current.value = data['filled']['fathertel'];
					
					
					mothername.current.value = data['filled']['mothername'];
					motheraddr.current.value = data['filled']['motheraddr'];
					mothertel.current.value = data['filled']['mothertel'];
					
					guardianname.current.value = data['filled']['guardianname'];
					guardianrel.current.value = data['filled']['guardianrel'];
					guardiantel.current.value = data['filled']['guardiantel'];
					
					fmember1name.current.value = data['filled']['fmember1name'];
					fmember1rel.current.value = data['filled']['fmember1rel'];
					fmember2name.current.value = data['filled']['fmember2name'];
					fmember2rel.current.value = data['filled']['fmember2rel'];
					
					fmember3name.current.value = data['filled']['fmember3name'];
					fmember3rel.current.value = data['filled']['fmember3rel'];
					
					fmember4name.current.value = data['filled']['fmember4name'];
					fmember4rel.current.value = data['filled']['fmember4rel'];
					
				
					fmember5name.current.value = data['filled']['fmember5name'];
					fmember5rel.current.value = data['filled']['fmember5rel'];

					fmember6name.current.value = data['filled']['fmember6name'];
					fmember6rel.current.value = data['filled']['fmember6rel'];

					fmember7name.current.value = data['filled']['fmember7name'];
					fmember7rel.current.value = data['filled']['fmember7rel'];

					fmember8name.current.value = data['filled']['fmember8name'];
					fmember8rel.current.value = data['filled']['fmember8rel'];

					
					descr1a.current.value = data['filled']['descr1a'];
					descr1b.current.value = data['filled']['descr1b'];
					descr1c.current.value = data['filled']['descr1c'];
					
					descr2a.current.value = data['filled']['descr2a'];
					descr2b.current.value = data['filled']['descr2b'];
					descr2c.current.value = data['filled']['descr2c'];
					
					descr3a.current.value = data['filled']['descr3a'];
					descr3b.current.value = data['filled']['descr3b'];
					descr3c.current.value = data['filled']['descr3c'];
					
					descrother.current.value = data['filled']['descrother'];
					descrremark.current.value = data['filled']['descrremark'];
										
					
					
				} else {
					sid.current.value = data['sid'];
				}
				
			} else {
				navigate("/application/login", { replace: true })
			}
		})
		.catch((err) => console.log('error' , err));
		
	},[]);
		
	const validate = () => {
		
		//if ( mc['sem'] ==''){
		//	msg('"請選擇宿期:"');
		//	return;
		//}
		//if ( sid.current.value==''){
		//	msg('1.1 Student Id No. 學生証號碼');
		//	return;
		//}
		
		/*
		if ( studentChiName.current.value==''){			
			if (lang=='tc') msg('1.2 中文姓名');
			if (lang=='sc') msg('1.2 中文姓名');
			if (lang=='eng') msg('1.2 Chinese Name');
			return;
		}*/
		
		if ( studentEngName.current.value==''){
			if (lang=='tc')msg('1.2 英文姓名');
			if (lang=='sc')msg('1.2 英文姓名');
			if (lang=='eng')msg('1.2 Full Name of English');
			return;
		}
		if ( mc['gender'] ==''){
			if (lang=='tc')msg('1.4 性別 ');
			if (lang=='sc')msg('1.4 性別 ');
			if (lang=='eng')msg('1.4 Gender');
			return;
		}
				
		
		
		if ( yearOfStudy.current.value==''){
			
			if (lang=='tc')msg('1.5 修業年 (E.g. Yr 2)');
			if (lang=='sc')msg('1.5 修业年 (E.g. Yr 2)');
			if (lang=='tc')msg('1.5 Year of Study (E.g. Yr 2)');
			return;
		}
		
		if ( tel.current.value==''){
			if (lang=='tc')msg('1.6 本地手機號碼');
			if (lang=='sc')msg('1.6 本地手机号码');
			if (lang=='eng')msg('1.6 Local Mobile phone number');
			return;
		}
		
		if ( email.current.value==''){
			if (lang=='tc')msg('1.7 電郵地址');
			if (lang=='sc')msg('1.7 电邮地址');
			if (lang=='eng')msg('1.7 Email Address');
			return;
		}
		
		
		if ( bankname.current.value==''){
			if (lang=='tc')msg('1.8 本地銀行名稱');
			if (lang=='sc')msg('1.8 本地银行名称');
			if (lang=='eng')msg('1.8 Local Bank Name');
			return;
		}
		
		if ( bankcode.current.value==''){
			if (lang=='tc')msg('1.9 銀行代碼 (e.g. HSB - 024)');
			if (lang=='sc')msg('1.9 银行代码 (e.g. HSB - 024)');
			if (lang=='eng')msg('1.9 Bank Code (e.g. HSB - 024)');
			return;
		}
		if ( bankac.current.value==''){
			if (lang=='tc')msg('1.10 戶口號碼');
			if (lang=='sc')msg('1.10 户口号码');
			if (lang=='eng')msg('1.10 Account No.');
			return;
		}
		
		/*
		if ( bankcode.current.value==''){
			if (lang=='tc')msg('1.10 銀行代碼 (e.g. HSB - 024)');
			if (lang=='sc')msg('1.10 银行代码 (e.g. HSB - 024)');
			if (lang=='eng')msg('1.10 Bank Code (e.g. HSB - 024)');
			return;
		}
		if ( bankac.current.value==''){
			if (lang=='tc')msg('1.11 戶口號碼');
			if (lang=='sc')msg('1.11 户口号码');
			if (lang=='eng')msg('1.11 Account No.');
			return;
		}		
		*/
		/*
		if ( gact['act1']!='' || org1.current.value!='' || position1.current.value!='' || dpicker['org1from']!='--'  || dpicker['org1to']!='--'){
			if (org1.current.value==''){
				if (lang=='tc')msg('2.1 一般課外活動 -> 團體名稱 (1)');
				if (lang=='sc')msg('2.1 一般课外活动 -> 团体名称 (1)');
				if (lang=='eng')msg('2.1 General Activities -> Name of Organization (1)');
				return;
			}
			if (position1.current.value==''){
				if (lang=='tc')msg('2.1 一般課外活動 -> 職位 (1)');
				if (lang=='sc')msg('2.1 一般课外活动 -> 职位 (1)');
				if (lang=='eng')msg('2.1 General Activities -> Position (1)');
				return;
			}
			if (dpicker['org1from']=='--'){
				if (lang=='tc')msg('2.1 一般課外活動 -> 由');
				if (lang=='sc')msg('2.1 一般课外活动 -> 由');
				if (lang=='eng')msg('2.1 General Activities -> From ');
				return;
			}
			if (dpicker['org1to']=='--'){
				if (lang=='tc')msg('2.1 一般課外活動 -> 至');
				if (lang=='sc')msg('2.1 一般课外活动 -> 至');
				if (lang=='eng')msg('2.1 General Activities -> To ');
				return;
			}
			if (gact['act1']==''){
				if (lang=='tc')msg('2.1 一般課外活動(1) (category) ');
				if (lang=='sc')msg('2.1 一般课外活动(1) (category) ');
				if (lang=='eng')msg('2.1 General Activities(1) (category) ');
				return;
			}	
		}		
		
		if ( gact['act2']!='' || org2.current.value!='' || position2.current.value!='' || dpicker['org2from']!='--'  || dpicker['org2to']!='--'){
			if (org2.current.value==''){
				if (lang=='tc')msg('2.1 一般課外活動 -> 團體名稱 (2)');
				if (lang=='sc')msg('2.1 一般课外活动 -> 团体名称 (2)');
				if (lang=='eng')msg('2.1 General Activities -> -> Name of Organization (2)');
				return;
			}
			if (position2.current.value==''){
				if (lang=='tc')msg('2.1 一般課外活動 -> 職位 (2)');
				if (lang=='sc')msg('2.1 一般课外活动 -> 职位 (2)');
				if (lang=='eng')msg('2.1 General Activities -> Position (2)');
				return;
			}
			if (dpicker['org2from']=='--'){
				if (lang=='tc')msg('2.1 一般課外活動 -> 由');
				if (lang=='sc')msg('2.1 一般课外活动 -> 由');
				if (lang=='eng')msg('2.1 General Activities -> From');
				return;
			}
			if (dpicker['org2to']=='--'){
				if (lang=='tc')msg('2.1 一般課外活動 -> 至');
				if (lang=='sc')msg('2.1 一般课外活动 -> 至');
				if (lang=='eng')msg('2.1 General Activities -> To');
				return;
			}
			if (gact['act2']==''){
				if (lang=='tc')msg('2.1 一般課外活動(2) (category) ');
				if (lang=='sc')msg('2.1 一般课外活动(2) (category) ');
				if (lang=='eng')msg('2.1 General Activities(2) (category) ');
				return;
			}
		}	
		*/
		/*
		if ( addrroom.current.value==''){
			msg('3.1 Room No.室/門牌');
			return;
		}
		
		if ( addrfloor.current.value==''){
			msg('3.1 Floor 層');
			return;
		}
		if ( addrblock.current.value==''){
			msg('3.1 Block 座');
			return;
		}
		if ( addrbldg.current.value==''){
			msg('3.1 Bldg./Mansion/Site 樓/座/閣');
			return;
		}
		if ( addrest.current.value==''){
			msg('3.1 Est/Gdn/Crt/Village 屋村/屋苑');
			return;
		}
		if ( addrrd.current.value==''){
			msg('3.1 Rd & Rd# 街道/巷/里');
			return;
		}
		if ( addrdist.current.value==''){
			msg('3.1 District 區域');
			return;
		}
		if ( addrchi.current.value==''){
			msg('3.2 Chinese Address, if any 中文住址 (如有)');
			return;
		}
		if ( addrtel.current.value==''){
			msg('3.3 Residential Tel. No. 住址電話');
			return;
		}
		*/
		/*if ( districtpoints.current.value==''){
			if (lang=='tc')msg('3.4 地區分 (採用谷歌地圖提供的車程時間)');
			if (lang=='sc')msg('3.4 地区分 (采用谷歌地图提供的车程时间)');
			if (lang=='eng')msg('3.4 District Points (travelling time examined by Google Map)');
			return;
		}	
		
		if ( /^\d+$/.test(districtpoints.current.value.trim()) == false){
			if (lang=='tc')msg('3.4 地區分 只可輸入數字');
			if (lang=='sc')msg('3.4 地区分 只可输入数字');
			if (lang=='eng')msg('3.4 District Points Only Digit is allow');
			return;
		}
		*/
				
		//if ( mc['householdtype'] ==''){			
		//	if (lang=='tc')msg('4.1 住所类型');
		//	if (lang=='sc')msg('4.1 住所類型');
		//	if (lang=='eng')msg('4.1 Household Type');
		//	return;
		//}	
			
		/*if ( mc['householdarea'] ==''){
			if (lang=='tc')msg('4.2 人均面積');
			if (lang=='sc')msg('4.2 人均面积');
			if (lang=='eng')msg('4.2 Household Area per Capita');			
			return;
		}	*/
				
		/*
		
		if ( fmember1name.current.value==''){
			msg('5. Information on Family Members 家庭成員資料 > Name 姓名(1)');
			return;
		}		
		if ( fmember1rel.current.value==''){
			msg('5. Information on Family Members 家庭成員資料 > Relationship 關係 (1)');
			return;
		}
		
		if ( fmember2name.current.value==''){
			msg('5. Information on Family Members 家庭成員資料 > Name 姓名(2)');
			return;
		}		
		if ( fmember2rel.current.value==''){
			msg('5. Information on Family Members 家庭成員資料 > Relationship 關係 (2)');
			return;
		}
		
		if ( fmember3name.current.value==''){
			msg('5. Information on Family Members 家庭成員資料 > Name 姓名(3)');
			return;
		}		
		if ( fmember3rel.current.value==''){
			msg('5. Information on Family Members 家庭成員資料 > Relationship 關係 (3)');
			return;
		}
		
		
		if ( fmember4name.current.value==''){
			msg('5. Information on Family Members 家庭成員資料 > Name 姓名(4)');
			return;
		}		
		if ( fmember4rel.current.value==''){
			msg('5. Information on Family Members 家庭成員資料 > Relationship 關係 (4)');
			return;
		}
		
		if ( fmember5name.current.value==''){
			msg('5. Information on Family Members 家庭成員資料 > Name 姓名(5)');
			return;
		}		
		if ( fmember5rel.current.value==''){
			msg('5. Information on Family Members 家庭成員資料 > Relationship 關係 (5)');
			return;
		}
		
		if ( fmember6name.current.value==''){
			msg('5. Information on Family Members 家庭成員資料 > Name 姓名(6)');
			return;
		}		
		if ( fmember6rel.current.value==''){
			msg('5. Information on Family Members 家庭成員資料 > Relationship 關係 (6)');
			return;
		}
		
		if ( fmember7name.current.value==''){
			msg('5. Information on Family Members 家庭成員資料 > Name 姓名(7)');
			return;
		}		
		if ( fmember7rel.current.value==''){
			msg('5. Information on Family Members 家庭成員資料 > Relationship 關係 (7)');
			return;
		}
		
		if ( fmember8name.current.value==''){
			msg('5. Information on Family Members 家庭成員資料 > Name 姓名(8)');
			return;
		}		
		if ( fmember8rel.current.value==''){
			msg('5. Information on Family Members 家庭成員資料 > Relationship 關係 (8)');
			return;
		}
		
		
		if ( fathername.current.value==''){
			msg("5.2 Parents' and Guardian's Information 父、母、監護人資料 > Father's Name 父親姓名 ");
			return;
		}
		if ( mc['fatherstatus'] ==''){
			msg("5.2 Parents' and Guardian's Information 父、母、監護人資料 > Father 父親 [Alive 存 / Deceased 歿]");
			return;
		}	
		if ( fatheraddr.current.value==''){
			msg("5.2 Parents' and Guardian's Information 父、母、監護人資料 > Father's Residential Address 父親居住地址 ");
			return;
		}		
		if ( fathertel.current.value==''){
			msg("5.2 Parents' and Guardian's Information 父、母、監護人資料 > Father's Contact No. 父親聯絡電話 ");
			return;
		}
		
		
		if ( mothername.current.value==''){
			msg("5.2 Parents' and Guardian's Information 父、母、監護人資料 > Mother's Name 母親姓名 ");
			return;
		}
		if ( mc['motherstatus'] ==''){
			msg("5.2 Parents' and Guardian's Information 父、母、監護人資料 > Mother 母親 [Alive 存 / Deceased 歿]");
			return;
		}	
		if ( motheraddr.current.value==''){
			msg("5.2 Parents' and Guardian's Information 父、母、監護人資料 > Mother's Residential Address 母親居住地址 ");
			return;
		}		
		if ( mothertel.current.value==''){
			msg("5.2 Parents' and Guardian's Information 父、母、監護人資料 > Mother's Contact No.母親聯絡電話 ");
			return;
		}
		*/	
			
		if ( mc['hostel_c'] ==''){
			if (lang=='tc')msg('5.1 申請人志願 (請依次序填上1、2、3、4、5、6)');
			if (lang=='sc')msg('5.1 申请人志愿 (请依次序填上1、2、3、4、5、6)');
			if (lang=='eng')msg('5.1 Hostel Preference (from 1 to 6)');
			return;
		}	
		if ( mc['hostel_d'] ==''){
			if (lang=='tc')msg('5.1 申請人志願 (請依次序填上1、2、3、4、5、6)');
			if (lang=='sc')msg('5.1 申请人志愿 (请依次序填上1、2、3、4、5、6)');
			if (lang=='eng')msg('5.1 Hostel Preference (from 1 to 6)');
			return;
		}
		if ( mc['hostel_g'] ==''){
			if (lang=='tc')msg('5.1 申請人志願 (請依次序填上1、2、3、4、5、6)');
			if (lang=='sc')msg('5.1 申请人志愿 (请依次序填上1、2、3、4、5、6)');
			if (lang=='eng')msg('5.1 Hostel Preference (from 1 to 6)');
			return;
		}
		if ( mc['hostel_x'] ==''){
			if (lang=='tc')msg('5.1 申請人志願 (請依次序填上1、2、3、4、5、6)');
			if (lang=='sc')msg('5.1 申请人志愿 (请依次序填上1、2、3、4、5、6)');
			if (lang=='eng')msg('5.1 Hostel Preference (from 1 to 6)');
			return;
		}
		if ( mc['hostel_i'] ==''){
			if (lang=='tc')msg('5.1 申請人志願 (請依次序填上1、2、3、4、5、6)');
			if (lang=='sc')msg('5.1 申请人志愿 (请依次序填上1、2、3、4、5、6)');
			if (lang=='eng')msg('5.1 Hostel Preference (from 1 to 6)');
			return;
		}		
		
		if ( mc['hostel_m'] ==''){
			if (lang=='tc')msg('5.1 申請人志願 (請依次序填上1、2、3、4、5、6)');
			if (lang=='sc')msg('5.1 申请人志愿 (请依次序填上1、2、3、4、5、6)');
			if (lang=='eng')msg('5.1 Hostel Preference (from 1 to 6)');
			return;
		}
		
		if (['c','d','g','x','i','m'].every(x=>mc['hostel_'+x]!='')){
			let choose = [true,false,false,false,false,false,false]; // if there are 6 hostels , the array length = 7, the first element of array is placeholder , must be true
			['c','d','g','x','i','m'].forEach(x=>{
				choose[mc['hostel_'+x]] = true; //  mc['hostel_'+x] will return 0 or 1 or 2, etc
			});
			if (!choose.every(x=>x)){				
				if (lang=='tc')msg('5.1 申請人志願 (請依次序填上1、2、3、4、5、6)');
				if (lang=='sc')msg('5.1 申请人志愿 (请依次序填上1、2、3、4、5、6)');
				if (lang=='eng')msg('5.1 Hostel Preference (from 1 to 6)');
				return;
			}
		}
	
		if ( mc['room_2'] ==''){
			if (lang=='tc')msg('5.2 房間類型志願 (請依次序填上 1、2、3)');
			if (lang=='sc')msg('5.2 房间类型志愿 (请依次序填上 1、2、3)');
			if (lang=='eng')msg('5.2 Room Preference (from 1 to 3)');
			return;
		}			
		if ( mc['room_3'] ==''){
			if (lang=='tc')msg('5.2 房間類型志願 (請依次序填上 1、2、3)');
			if (lang=='sc')msg('5.2 房间类型志愿 (请依次序填上 1、2、3)');
			if (lang=='eng')msg('5.2 Room Preference (from 1 to 3)');
			return;
		}			
		if ( mc['room_3c'] ==''){
			if (lang=='tc')msg('5.2 房間類型志願 (請依次序填上 1、2、3)');
			if (lang=='sc')msg('5.2 房间类型志愿 (请依次序填上 1、2、3)');
			if (lang=='eng')msg('5.2 Room Preference (from 1 to 3)');
			return;
		}	
		
		if (['2','3','3c'].every(x=>mc['room_'+x]!='')){
			let choose = [true,false,false,false];
			['2','3','3c'].forEach(x=>{
				choose[mc['room_'+x]] = true;
			});
			if (!choose.every(x=>x)){				
				if (lang=='tc')msg('5.2 房間類型志願 (請依次序填上 1、2、3)');
				if (lang=='sc')msg('5.2 房间类型志愿 (请依次序填上 1、2、3)');
				if (lang=='eng')msg('5.2 Room Preference (from 1 to 3)');
				return;
			}
		}
		
		if ( mc['declaration1'] ==''){
			msg('8. Declaration');
			return;
		}			
		if ( mc['declaration2'] ==''){
			msg('8. Declaration');
			return;
		}	
		if ( mc['declaration3'] ==''){
			msg('8. Declaration');
			return;
		}	
		if ( mc['declaration4'] ==''){
			msg('8. Declaration');
			return;
		}	
		//if ( mc['declaration4'] ==''){
		//	msg('7. Declaration');
		//	return;
		//}	
		
		/*
		if ( xxxxxxxxxx.current.value==''){
			msg('xxxxxxxxxxxxx');
		}
		if ( mc['xxxxxxxxxxx'] ==''){
			msg('xxxxxxxxxxxx');
		}	
		*/
		submit();
	}
	
	
	const logout = () => {
		localStorage.setItem('jwtapplication1','');
		navigate("/application/login", { replace: true })
	}
		
	//const change_bankcode = (bb) => {		
	//	bankcode.current.value = bb;		
	//}
	
	const submit = () => {
		
		let submitdata = {
			sid: sid.current.value,
			studentChiName: studentChiName.current.value,
			studentEngName: studentEngName.current.value,
			
			yearOfStudy: yearOfStudy.current.value,
			tel: tel.current.value,
			email: email.current.value,
			bankname: bankname.current.value,
			bankcode: bankcode.current.value,
			bankac: bankac.current.value,			//
			
			//org1: org1.current.value,
			//org1_category:gact['act1'], 
			//position1: position1.current.value,
			//org2: org2.current.value,
			//org2_category:gact['act2'],
			//position2: position2.current.value,
			addrroom: addrroom.current.value,
			addrfloor: addrfloor.current.value,
			addrblock: addrblock.current.value,
			addrbldg: addrbldg.current.value,
			
			addrest: addrest.current.value,
			addrrd: addrrd.current.value,
			addrdist: addrdist.current.value,
			addrchi: addrchi.current.value,
			//addr: addr.current.value,
			addrtel: addrtel.current.value,
			//districtpoints: districtpoints.current.value,
			
			
			fathername: fathername.current.value,			
			fathertel: fathertel.current.value,
			fatheraddr: fatheraddr.current.value,
			//fatherstatus: fatherstatus.current.value,
			
			mothername: mothername.current.value,			
			mothertel: mothertel.current.value,
			motheraddr: motheraddr.current.value,
			//motherstatus: motherstatus.current.value,
			
			guardianname: guardianname.current.value,
			guardianrel: guardianrel.current.value,
			guardiantel: guardiantel.current.value,
			
			
			fmember1name :fmember1name.current.value,
			fmember1rel : fmember1rel.current.value,			
			fmember2name : fmember2name.current.value,
			fmember2rel : fmember2rel.current.value,
			
			fmember3name : fmember3name.current.value,
			fmember3rel : fmember3rel.current.value,
			fmember4name : fmember4name.current.value,
			fmember4rel : fmember4rel.current.value,
			
			fmember5name: fmember5name.current.value,
			fmember5rel : fmember5rel.current.value,
			fmember6name : fmember6name.current.value,
			fmember6rel : fmember6rel.current.value,
			
			fmember7name : fmember7name.current.value,
			fmember7rel : fmember7rel.current.value,
			fmember8name : fmember8name.current.value,
			fmember8rel : fmember8rel.current.value,
						
			descr1a: descr1a.current.value,
			descr1b: descr1b.current.value,
			descr1c: descr1c.current.value,
			descr2a: descr2a.current.value,
			descr2b: descr2b.current.value,
			descr2c: descr2c.current.value,
			descr3a: descr3a.current.value,
			descr3b: descr3b.current.value,
			descr3c: descr3c.current.value,
			
			descrother: descrother.current.value,
			descrremark: descrremark.current.value,	

			wantreason:wantreason.current.value,
			wantrecord:wantrecord.current.value,
		};		
		submitdata = {attachfile:JSON.stringify(state.uploaded),...submitdata,...mc}; 		
		let url = URL0 + "/post_application.php?action=apply";				
		fetch(url, {
			method: "POST", 
			headers: {
				'JWT': localStorage.getItem('jwtapplication1')
			},
			body: JSON.stringify(submitdata) 
		})
		.then(res => res.text())
		.then(res => {
			console.log('x' , res);
			//setLoaded(true);	
			sysmsg( (lang=='tc'?'已儲存':'') + (lang=='eng'?'Saved':'') + (lang=='sc'?'已储存':'') );			
		})
		.catch(err => console.log(err))
		.finally(() => {});				
	}
	
	
	//const change_bankname = (ee) => {				
	//	bankname.current.value = ee;
	//}
	

	return (
		<Context.Provider value={{state,dispatch}} >
    <div style={{paddingTop:'20px',display:init?'block':'none'}} className="appform container-lg" >
	
		<div style={{display:'flex',justifyContent:'space-between',
			flexDirection:'column',width:"100%",border:"0px solid black"}}>
			<img src={logo} className="cuhklogo" />
						
			<div style={{flexDirection:'column',
						justifyContent:'flex-end',
						display:'flex',						
						alignItems:'flex-end',
						border:"0px solid black",
						paddingRight:'0px'}}>
				<div>					
				</div>
				<div >					
					<span style={{cursor:'pointer',marginLeft:'10px'}} onClick={()=> { dispatch({type:'setLang',value:'tc'}); }} > 繁 </span>
					<span style={{cursor:'pointer',marginLeft:'10px'}} onClick={()=> { dispatch({type:'setLang',value:'sc'});  }} > 简 </span>
					<span style={{cursor:'pointer',marginLeft:'10px'}} onClick={()=> { dispatch({type:'setLang',value:'eng'}); }} > Eng </span>					
				</div>
				<hr />
				<span> <div >										
					{lang=='eng' && <span style={{cursor:'pointer',marginLeft:'10px'}} onClick={logout} > Logout </span> }
					{lang=='tc' && <span style={{cursor:'pointer',marginLeft:'10px'}} onClick={logout} > 登出 </span> }
					{lang=='sc' && <span style={{cursor:'pointer',marginLeft:'10px'}} onClick={logout} > 登出 </span> }
				</div></span>
				
			</div>
			
		</div>
		<br />
		<br />	
		<br />

				
		<Modal show={show1} onHide={()=>setShow1(false)}>
			<Modal.Header closeButton>
			<Modal.Title>{lang=='eng'?'Message':''}{lang=='sc'?'讯息':''}{lang=='tc'?'訊息':''}</Modal.Title>
			</Modal.Header>
			{message!='' && <Modal.Body>			
			{lang=='tc'?'請先填妥':''}{lang=='eng'?'Please fill in ':''}{lang=='sc'?'请先填妥':''}「 {message} 」
			</Modal.Body>}
			
			{sysmessage!='' && <Modal.Body>			
			{sysmessage} 
			</Modal.Body>}
			
			 <Modal.Footer>
			<Button variant="secondary" onClick={()=>setShow1(false)}>
			{lang=='eng'?'Close':''}{lang=='sc'?'关闭':''}{lang=='tc'?'關閉':''}
			</Button>
			
			</Modal.Footer>
		</Modal>
		
		
		
		<Modal show={gactmode!=''} onHide={()=>setGactmode('')}>
		
			<Modal.Header closeButton>
			<Modal.Title>{lang=='eng'?'Message':''}{lang=='sc'?'讯息':''}{lang=='tc'?'訊息':''}</Modal.Title>
			</Modal.Header>
			
			<Modal.Body>			
			<table>
			{lang=='tc' && <tr>
				<th> 職位／計劃 </th>
				<th>書院</th>
				<th>中大</th>
			</tr>}
			
			{lang=='sc' && <tr>
				<th> 职位／计划 </th>
				<th>书院</th>
				<th>中大</th>
			</tr>}
			
			{lang=='eng' && <tr>
				<th> Position/ Scheme </th>
				<th>New Asia College</th>
				<th>CUHK</th>
			</tr>}
		
			
			
			</table>
			
			</Modal.Body>
						
			<Modal.Footer>
			<Button variant="secondary" onClick={()=>setGactmode('')}>
			{lang=='eng'?'Save':''}{lang=='sc'?'储存':''}{lang=='tc'?'儲存':''}
			</Button>
			
			</Modal.Footer>
		</Modal>
			
		<div style={{fontSize:"30px",...eng}}> 
		Application for Student Hostel of New Asia College (Current Non-local Students) {year} 
		</div>
		
		<div style={{fontSize:"30px",...tc}}> 		
		香港中文大學新亞書院學生宿舍申請 (非本地舊生) {year}
		</div>
		
		<div style={{fontSize:"30px",...sc}}> 		
		香港中文大学新亚书院学生宿舍申请 (非本地旧生) {year}
		</div>
		
		<br />				
		
		<div style={{...eng}}> Notes: </div>
		<div style={{...tc}}> 注意: </div>
		<div style={{...sc}}> 注意: </div>
		
		<br /> 
		<br /> 
		
		<div style={{...eng}}> (1) Applicants submitting false statements are liable to the following penalties:<br /> </div>
		<div style={{...tc}}>(1) 虛報資料，將有以下列處分：<br /> </div>
		<div style={{...sc}}>(1) 虚报资料，将有以下列处分：<br /> </div>
		
		<br /> 
		
		<div style={{...eng}}>
		i ) Without hostel allocation : Students will be disqualified in this application and that of the following year, referred to the Committee on Student Discipline and to bear criminal liability.<br /> 
		ii ) With hostel allocation : Students will have their places recalled and hostel fees forfeited. They will be disqualified in the hostel application of the following year, referred to the Committee on Student Discipline and to bear criminal liability.<br /><br />  
		</div>		
		
		<div style={{...tc}}>
		i ) 未獲配宿位者：取消是次及來年申請資格，送交學生紀律委員會處理，並承擔個人刑事責任。<br /> 
		ii ) 已獲配宿位者：取消宿位，沒收一學年宿費，取消來年申請資格，送交學生紀律委員會處理，並承擔個人刑事責任。<br /> <br /> 
		</div>
		
		
		<div style={{...sc}}>
		i ) 未获配宿位者：取消是次及来年申请资格，送交学生纪律委员会处理，并承担个人刑事责任。<br /> 
		ii ) 已获配宿位者：取消宿位，没收一学年宿费，取消来年申请资格，送交学生纪律委员会处理，并承担个人刑事责任。<br /> <br /> 
		</div>
		
		<div style={{...eng}}>
		
		(2) Applicants should state all the information clearly. Incomplete and unclear statements may lead to failures or delays of applications. No appealson the aforementioned will be accepted.<br /><br />  		
		(3) All information provided in this form will be used for hostel applications and destroyed in due course.<br /> <br /> 		
		(4) Incomplete applications will not be accepted. Late applications will be handled behind the waiting list.<br /> <br />
		(5) Multiply submissions of the online application are accepted within the designated application period(s). However, only the final submissionrecord will be processed. Late information submission or amendment may not be accepted.<br /><br />
		</div>
		
		<div style={{...tc}}>
		(2) 申請人應清楚填報各項資料。漏填資料或填寫不清楚，可導致申請失敗或延誤，事後追訴，將不獲受理。<br /> <br /> 
		(3) 此表格所收集的資料將用以處理有關的申請，所提供的資料於無需保留時將全部銷毀。<br /> <br /> 
		(4) 尚未完成填妥之申請表格，將不予受理。逾期遞交之申請，將會安排在正宿的輪候名單之後，再作處理。<br /> <br /> 
		(5) 申請人可在截止日期前不限次數地遞交申請，但只有最後提交的申請會獲得處理。申請期截止後，逾時申請或任何修訂要求概不受理。<br /> <br /> 
		</div>
		
		<div style={{...sc}}>
		(2) 申请人应清楚填报各项资料。漏填资料或填写不清楚，可导致申请失败或延误，事后追诉，将不获受理。<br /> <br /> 
		(3) 此表格所收集的资料将用以处理有关的申请，所提供的资料于无需保留时将全部销毁。<br /> <br /> 
		(4) 尚未完成填妥之申请表格，将不予受理。逾期递交之申请，将会安排在正宿的轮候名单之后，再作处理。<br /> <br /> 
		(5) 申请人可在截止日期前不限次数地递交申请，但只有最后提交的申请会获得处理。申请期截止后，逾时申请或任何修订要求概不受理。<br /> <br /> 
		</div>
		

		<div style={{...eng}}>Application Deadline : {periodTo}</div>
		<div style={{...tc}}>截止申請日期：{periodTo} </div>
		<div style={{...sc}}>截止申请日期：{periodTo} </div>
		
		<br /><br />
		
		<hr />		
		
		
		<div style={{...eng}}>Please select your preferred residence period:</div>
		<div style={{...tc}}>請選擇宿期:</div>
		<div style={{...sc}}>请选择宿期:</div>
		
		<br />
		
		<input type='radio' checked={mc.sem=='fullyear'} onChange={()=> mce({'sem':'fullyear'})} name='sem'/> 
		
		<span style={{...eng}}>Whole Year</span>
		<span style={{...tc}}>全年</span>
		<span style={{...sc}}>全年</span>
		
		<br />
		<input type='radio' checked={mc.sem=='sem1'} onChange={()=> mce({'sem':'sem1'})} name='sem'/>
		<span style={{...eng}}>The 1st Semester</span>
		<span style={{...tc}}>第一學期</span>
		<span style={{...sc}}>第一学期</span>
		<br />
		<input type='radio' checked={mc.sem=='sem2'} onChange={()=> mce({'sem':'sem2'})} name='sem'/> 
		<span style={{...eng}}>The 2nd Semester</span>
		<span style={{...tc}}>第二學期</span>
		<span style={{...sc}}>第二学期</span>
		<br />
		<br />
		
		
		
<span className='smalltitle'>1. &nbsp;
<span style={{...eng}}>Personal Inforamtion </span>
<span style={{...tc}}>個人資料</span>
<span style={{...sc}}>个人资料</span>
</span><br /><br />

<span className='smalltitle'>1.1 &nbsp;
<span style={{...eng}}>Student ID No. </span>
<span style={{...tc}}>學生証號碼</span>
<span style={{...sc}}>学生证号码</span> <Star />
</span>

<br />
<input type='text' readOnly ref={el=>sid.current=el} /> <br /><br />




<span className='smalltitle'>1.2 &nbsp;
<span style={{...eng}}>Full Name of English </span>
<span style={{...tc}}>英文姓名 </span>
<span style={{...sc}}>英文姓名 </span>
</span><Star />
<br />
<input type='text' disabled={!inPeriod} ref={el=>studentEngName.current=el} /> <br /><br />

<span className='smalltitle'>1.3 &nbsp;
<span style={{...eng}}>Full Name of Chinese (if applicable) </span>
<span style={{...tc}}>中文姓名 (若適用)</span>
<span style={{...sc}}>中文姓名 (若適用)</span>
</span> <br />
<input type='text' disabled={!inPeriod} ref={el=>studentChiName.current=el} /> <br /><br />


<span className='smalltitle'>1.4 &nbsp;
<span style={{...eng}}>Sex </span>
<span style={{...tc}}>性別 </span>
<span style={{...sc}}>性別 </span>
<Star /></span><br />

<input type='radio' disabled={!inPeriod} checked={mc.gender=='male'} onChange={()=> mce({'gender':'male'})} name='gender' />
<span style={{...eng}}>Male </span>
<span style={{...tc}}>男</span>
<span style={{...sc}}>男</span>
<br />
<input type='radio' disabled={!inPeriod} checked={mc.gender=='female'} onChange={()=> mce({'gender':'female'})} name='gender' />
<span style={{...eng}}>Female </span>
<span style={{...tc}}>女</span>
<span style={{...sc}}>女</span>
<br /><br />



<span className='smalltitle'>1.5 &nbsp;
<span style={{...eng}}> {year} Year of Study (E.g. Yr 2)</span>
<span style={{...tc}}> {year} 修業年 (E.g. Yr 2)</span>
<span style={{...sc}}> {year} 修业年 (E.g. Yr 2)</span><Star /> </span><br />
<input type='text' disabled={!inPeriod} ref={el=>yearOfStudy.current=el} /><br />
<br />


<span className='smalltitle'>1.6 &nbsp;
<span style={{...eng}}>Local Mobile </span>
<span style={{...tc}}>本地手機號碼 </span>
<span style={{...sc}}>本地手机号码 </span>
<Star /></span> <br />
<input type='text' disabled={!inPeriod} ref={el=>tel.current=el} /><br />
<br />

<span className='smalltitle'>1.7 &nbsp;
<span style={{...eng}}>Email Address </span>
<span style={{...tc}}>電郵地址 </span>
<span style={{...sc}}>电邮地址 </span>
<Star />
</span>
<br />


<input type='text' disabled={!inPeriod} ref={el=>email.current=el} /><br />
<br />



<span className='smalltitle'>1.8 &nbsp;
<span style={{...eng}}>Local Bank Name </span>
<span style={{...tc}}> 本地銀行名稱 </span> 
<span style={{...sc}}> 本地银行名称 </span> 
<Star />
</span> <br />
		
<input style={{display:'block'}} type='text' ref={el=>bankname.current=el} /><br />

<span className='smalltitle'>1.9 &nbsp;
<span style={{...eng}}>Bank Code </span>
<span style={{...tc}}>銀行代碼 </span> 
<span style={{...sc}}>银行代码 </span> 
(e.g. HSB - 024) <Star /> </span><br /> 
<input type='text'  ref={el=>bankcode.current=el}
	 /><br />

<br />

<span className='smalltitle'>1.10 &nbsp;
<span style={{...eng}}>Account No. </span>
<span style={{...tc}}>戶口號碼 </span>
<span style={{...sc}}>户口号码 </span>
<Star /></span><br />

<input type='text' ref={el=>bankac.current=el} /><br /><br />



<br />



<span style={{...eng}}> 2. Residential Address</span>
<span style={{...tc}}> 2. 住宅地址</span>
<span style={{...sc}}> 2. 住宅地址</span>
<br /><br />

<span className='smalltitle'>2.1 

<span style={{...eng}}> English Address</span>
<span style={{...tc}}> 英文地址</span>
<span style={{...sc}}> 英文地址</span>

</span><br /><br />
<span className='smalltitle'>
<span style={{...eng}}>Room No. </span>
<span style={{...tc}}>室/門牌  </span>
<span style={{...sc}}>室/门牌  </span>
</span><br />
<input type='text' ref={el=>addrroom.current=el} />  <br /> <br />

<span className='smalltitle'>
<span style={{...eng}}>Floor  </span>
<span style={{...tc}}>層  </span>
<span style={{...sc}}>层  </span>
</span><br />
<input type='text' ref={el=>addrfloor.current=el} />  <br /> <br />


<span className='smalltitle'>

<span style={{...eng}}>Block</span>
<span style={{...tc}}>座 </span>
<span style={{...sc}}>座 </span>

 
</span><br />

<span className='smalltitle'>
<input type='text' ref={el=>addrblock.current=el} /></span>  <br /> <br />

<span className='smalltitle'>
<span style={{...eng}}>Bldg./Mansion/Site </span>
<span style={{...tc}}>樓/座/閣 </span>
<span style={{...sc}}>楼/座/阁 </span>
 </span><br />
<input type='text'ref={el=>addrbldg.current=el} />  <br /> <br />

<span className='smalltitle'>
<span style={{...eng}}>Est/Gdn/Crt/Village  </span>
<span style={{...tc}}>屋村/屋苑 </span>
<span style={{...sc}}>屋村/屋苑 </span>
 </span><br />
<input type='text'ref={el=>addrest.current=el} />  <br /> <br />

<span className='smalltitle'>
<span style={{...eng}}>Rd & Rd#  </span>
<span style={{...tc}}>街道/巷/里  </span>
<span style={{...sc}}>街道/巷/里  </span>
</span><br />
<input type='text'ref={el=>addrrd.current=el} />  <br /> <br />

<span className='smalltitle'>
<span style={{...eng}}>District </span>
<span style={{...tc}}>區域  </span>
<span style={{...sc}}>区域  </span>
</span><br />
<input type='text'ref={el=>addrdist.current=el} />  <br /> <br />

<span className='smalltitle'>2.2&nbsp; 
<span style={{...eng}}>Chinese Address, if any  </span>
<span style={{...tc}}>中文住址 (如有)  </span>
<span style={{...sc}}>中文住址 (如有)  </span>
</span><br />

<input type='text'ref={el=>addrchi.current=el} />  <br /> <br />

<span className='smalltitle'>2.3&nbsp; 
<span style={{...eng}}>Residential Tel. No.  </span>
<span style={{...tc}}>住址電話  </span>
<span style={{...sc}}>住址电话 </span>
</span><br />
<input type='text' ref={el=>addrtel.current=el} />  <br /> <br />

	{/*
<span className='smalltitle'>2.4 &nbsp;
<span style={{...eng}}>District Points (travelling time examined by Google Map)  </span>
<span style={{...tc}}>地區分 (採用谷歌地圖提供的車程時間) </span>
<span style={{...sc}}>地区分 (采用谷歌地图提供的车程时间) </span>
<Star /> </span><br />
<a target='_blank' href='https://www.na.cuhk.edu.hk/college-life/facilities-and-hostels/student-hostels/'> 
https://www.na.cuhk.edu.hk/college-life/facilities-and-hostels/student-hostels/
</a>
<br />
<input type='text' ref={el=>districtpoints.current=el} />  <br /> <br />
	*/}

<hr />




<span style={{...eng}}>3 Extra Curricular Activities </span>
<span style={{...tc}}>3 課外活動 </span>
<span style={{...sc}}>3 课外活动 </span>

<div>
	
	{[	{yr:mc.positionyr1,activity:'activity1',field:'positionyr1',label:'3.1 ' + yearRange[0]},
		{yr:mc.positionyr2,activity:'activity2',field:'positionyr2',label:'3.2 ' + yearRange[1]},
		{yr:mc.positionyr3,activity:'activity3',field:'positionyr3',label:'3.3 ' + yearRange[2]}
		].map(item=>{
			return <>
					<br />
					{item['label']}
					<div style={{display:'grid',gridTemplateColumns:'repeat(2, 1fr)' }}>
					{position.map((x)=>{
						return <div style={{border:'0px solid red'}} key={x['id']}>
							
							<div><input  disabled={!inPeriod} type='checkbox' 
									key={x['id']+'check'}
								checked={(!!item['yr']?item['yr']:'').split(',').map(x=>x/1).indexOf(x['id'])!=-1} 
								onChange={()=> {
										if ( (!!item['yr']?item['yr']:'').split(',').map(x=>x/1).indexOf(x['id'])!=-1 ){												
											let o = {};
											o[item.field] = (!!item['yr']?item['yr']:'').split(',').map(x=>x/1).filter(k=>k!=x['id']).join(',');
											o[item.field] = o[item.field].split(',').map(x=>x/1).filter(x=>x>0).join(',');
											mce({...o});
										} else {	
											let o = {};
											o[item.field] = (!!item['yr']?item['yr']:'') + ',' + x['id'];
											o[item.field] = o[item.field].split(',').map(x=>x/1).filter(x=>x>0).join(',');
											mce({...o});
										}
								}} 
								 /> {x[lang]}						 
								</div>		
						</div>
					})}
					<br /><br />
					</div>
			
					<span style={{...eng}}> Please upload the documents with CUID and Name of Documents (e.g. 1155123456-NA Ocamp)</span>
					<span style={{...tc}}> 請上載文件,檔案應以學號及文件種類命名 (例:1155123456 書院迎新營)</span>
					<span style={{...sc}}> 请上载文件,档案应以学号及文件种类命名 (例:1155123456 书院迎新营)</span>
					<span style={{...eng}}> <br /> Registration Document issued by OSA/ NASU/ CU Sports Teams is required.</span>
					<span style={{...tc}}> <br /> 學生事務處/ 新亞學生會代表會/ 中大校隊簽發的登記證明書</span>
					<span style={{...sc}}> <br /> 学生事务处/ 新亚学生会代表会/ 中大校队签发的登记证明书</span>

					<Upload filter={[item['activity']]} />
					<br />
				</>
	})}
</div>
<br />
<span style={{...eng}}> 3.4 Programs organized by University which last for at least 3months <br /> 
	* A cap to the numbers of participation in the programs organized by the University would be fixed <br /> 
	* Actual Hours of participation would also be considered when assessing such programs</span>
<span style={{...tc}}> 3.4 大學組織的持續三個月或以上的相關項目 <br /> *專案參與人數會有確定的上限 <br /> *項目的貢獻時間也會成為獲得宿分的重要決定因素</span>
<span style={{...sc}}> 3.4 大学组织的持续三个月或以上的相关项目 *专案参与人数会有确定的上限 <br /> *项目的贡献时间也会成为获得宿分的重要决定因素</span>


<br /><br />
({yearRange[0]})<br />
<input type='text' disabled={!inPeriod} ref={el=>descr1a.current=el} />  <br /> <br />
<input type='text' disabled={!inPeriod} ref={el=>descr1b.current=el} />  <br /> <br />
<input type='text' disabled={!inPeriod} ref={el=>descr1c.current=el} />  <br /> <br />

({yearRange[1]})<br />
<input type='text' disabled={!inPeriod} ref={el=>descr2a.current=el} />  <br /> <br />
<input type='text' disabled={!inPeriod} ref={el=>descr2b.current=el} />  <br /> <br />
<input type='text' disabled={!inPeriod} ref={el=>descr2c.current=el} />  <br /> <br />

({yearRange[2]})<br />
<input type='text' disabled={!inPeriod} ref={el=>descr3a.current=el} />  <br /> <br />
<input type='text' disabled={!inPeriod} ref={el=>descr3b.current=el} />  <br /> <br />
<input type='text' disabled={!inPeriod} ref={el=>descr3c.current=el} />  <br /> <br />


<br />
3.5 <span style={{...eng}}> Others</span>
<span style={{...tc}}> 其他</span>
<span style={{...sc}}> 其他</span>

<br />

<input type='text' disabled={!inPeriod} ref={el=>descrother.current=el} />  <br /> <br />
<br />
Remarks <br />

<input type='text' disabled={!inPeriod} ref={el=>descrremark.current=el} />  <br /> <br />

<span style={{...eng}}> Please upload the documents with CUID and Name of Documents (e.g. 1155123456-NA Ocamp) <br /><br />
Registration Document issued by respective CU Organisations is required</span>

<span style={{...tc}}> 請上載文件,檔案應以學號及文件種類命名 (例:1155123456 書院迎新營) <br /><br />
中大相關團體簽發的登記證明書</span>
<br />
<span style={{...sc}}> 请上载文件,档案应以学号及文件种类命名 (例:1155123456 书院迎新营) <br /><br />
中大相关团体签发的登记证明书</span>
<br />

<Upload filter={['activity4']} />


<br /><br />

3.6 <span style={{...eng}}> Students who have not used up his/her guaranteed hostel place in their first 3 years of normative study.<br />
Example: If a student who has gone on exchange abroad with official document to duly certify that the host university for his/her exchange programs does NOT provide housing arrangement for him/her, then 20 hall points would be given to the concerned student.</span>
<span style={{...tc}}> 前三學年中未完全使用保宿名額<br />
具體例子，如學生在交換期間，交換學校未能提供校內或校外的住宿，則該學生在宿位遴選時將獲得額外的20 分加分。</span>
<span style={{...sc}}> 前三学年中未完全使用保宿名额 <br />
具体例子，如学生在交换期间，交换学校未能提供校内或校外的住宿，则该学生在宿位遴选时将获得额外的20 分加分。</span>


<div><input type='checkbox' 
	disabled={!inPeriod} 
	checked={mc.apply1=='yes'} 
	onChange={()=> mce({'apply1':mc.apply1=='yes'?'':'yes'})} 
	name='apply1' /> </div>
<br />



<span className='smalltitle'>

<hr/>	







<span className='smalltitle'>4. &nbsp;
<span style={{...eng}}>Information on Family Members  </span>
<span style={{...tc}}>家庭成員資料 </span>
<span style={{...sc}}>家庭成员资料 </span>
</span> <br /><br />



4.1 
<span style={{...eng}}> Family Members residing together at the above address (Please specify the relationships) </span>
<span style={{...tc}}> 上址居住人口 (請具體說明與申請人之關係) </span>
<span style={{...sc}}> 上址居住人口 (请具体说明与申请人之关系) </span>
<br /><br />




<div className="relationship">
	<div>
		<span className='smalltitle'>
		<span style={{...eng}}>Name </span>
		<span style={{...tc}}>姓名 </span>
		<span style={{...sc}}>姓名 </span>
		(1)</span><br />
		<input type='text'ref={el=>fmember1name.current=el} /> <br /><br />
	</div>
	<div>
		<span className='smalltitle'>
		<span style={{...eng}}>Relationship  </span>
		<span style={{...tc}}>關係 </span>
		<span style={{...sc}}>关系 </span>
		<span className='relationship-label-num'>(1)</span></span><br />
		<input type='text' ref={el=>fmember1rel.current=el} /> <br /><br />
	</div>
</div>

<div className="relationship">
	<div>
		<span className='smalltitle'>
		<span style={{...eng}}>Name </span>
		<span style={{...tc}}>姓名 </span>
		<span style={{...sc}}>姓名 </span>
		(2)</span><br />
		<input type='text' ref={el=>fmember2name.current=el}/> <br /><br />
	</div>
	<div>
		<span className='smalltitle'>
		<span style={{...eng}}>Relationship </span>
		<span style={{...tc}}>關係 </span>
		<span style={{...sc}}>关系 </span>
		<span className='relationship-label-num'>(2)</span></span><br />
		<input type='text' ref={el=>fmember2rel.current=el}/> <br /><br />
	</div>
</div>

<div className="relationship">
	<div>
		<span className='smalltitle'>
		<span style={{...eng}}>Name </span>
		<span style={{...tc}}>姓名 </span>
		<span style={{...sc}}>姓名 </span>
		(3)</span><br />
		<input type='text' ref={el=>fmember3name.current=el}/> <br /><br />
	</div>
	<div>
		<span className='smalltitle'>
		<span style={{...eng}}>Relationship </span>
		<span style={{...tc}}>關係 </span>
		<span style={{...sc}}>关系 </span>
		<span className='relationship-label-num'>(3)</span></span><br />
		<input type='text' ref={el=>fmember3rel.current=el}/> <br /><br />
	</div>
</div>

<div className="relationship">
	<div>		
		<span className='smalltitle'>
		<span style={{...eng}}>Name </span>
		<span style={{...tc}}>姓名</span>
		<span style={{...sc}}>姓名</span>
		(4)</span><br />
		<input type='text' ref={el=>fmember4name.current=el}/> <br /><br />
	</div>
	<div>
		<span className='smalltitle'>
		<span style={{...eng}}>Relationship </span>
		<span style={{...tc}}>關係 </span>
		<span style={{...sc}}>关系 </span>
		<span className='relationship-label-num'>(4)</span></span><br />
		<input type='text' ref={el=>fmember4rel.current=el}/> <br /><br />
	</div>
</div>


<div className="relationship">
	<div>
		<span className='smalltitle'>
		<span style={{...eng}}>Name </span>
		<span style={{...tc}}>姓名 </span>
		<span style={{...sc}}>姓名 </span>
		(5)</span><br />
		<input type='text' ref={el=>fmember5name.current=el}/> <br /><br />
	</div>
	<div>
		<span className='smalltitle'>
		<span style={{...eng}}>Relationship </span>
		<span style={{...tc}}>關係 </span>
		<span style={{...sc}}>关系 </span>
		<span className='relationship-label-num'>(5)</span></span><br />
		<input type='text' ref={el=>fmember5rel.current=el}/> <br /><br />
	</div>
</div>


<div className="relationship">
	<div>
		<span className='smalltitle'>
		<span style={{...eng}}>Name </span>
		<span style={{...tc}}>姓名 </span>
		<span style={{...sc}}>姓名 </span>
		(6)</span><br />
		<input type='text' ref={el=>fmember6name.current=el}/> <br /><br />
	</div>
	<div>
		<span className='smalltitle'>
		<span style={{...eng}}>Relationship </span>
		<span style={{...tc}}>關係 </span>
		<span style={{...sc}}>关系 </span>
		<span className='relationship-label-num'>(6)</span></span><br />
		<input type='text' ref={el=>fmember6rel.current=el}/> <br /><br />		
	</div>
</div>

	
<div className="relationship">
	<div>
		<span className='smalltitle'>
		<span style={{...eng}}>Name </span>
		<span style={{...tc}}>姓名 </span>
		<span style={{...sc}}>姓名 </span>


		(7)</span><br />
		<input type='text' ref={el=>fmember7name.current=el}/> <br /><br />
	</div>
	<div>		
		<span className='smalltitle'>		
		<span style={{...eng}}>Relationship </span>
		<span style={{...tc}}>關係 </span>
		<span style={{...sc}}>关系 </span>
		<span className='relationship-label-num'>(7)</span></span><br />
		<input type='text' ref={el=>fmember7rel.current=el}/> <br /><br />
	</div>	
</div>
	
<div className="relationship">
	<div>
		<span className='smalltitle'>
		<span style={{...eng}}>Name </span>
		<span style={{...tc}}>姓名 </span>
		<span style={{...sc}}>姓名 </span>
		(8)</span><br />
		<input type='text' ref={el=>fmember8name.current=el}/> <br /><br />
	</div>
	<div>				 
		<span className='smalltitle'>
		<span style={{...eng}}>Relationship </span>
		<span style={{...tc}}>關係 </span>
		<span style={{...sc}}>关系 </span>
		<span className='relationship-label-num'>(8)</span></span><br />
		<input type='text' ref={el=>fmember8rel.current=el}/> <br /><br />
	</div>
</div>




<br />
<span className='smalltitle'>4.2
<span style={{...eng}}> Parents' and Guardian's Information </span>
<span style={{...tc}}> 父、母、監護人資料 </span>
<span style={{...sc}}> 父、母、监护人资料 </span>
</span><br /><br />

<span className='smalltitle'>
<span style={{...eng}}>Father's Name </span>
<span style={{...tc}}>父親姓名 </span>
<span style={{...sc}}>父亲姓名 </span>
</span><br />
<input type='text' disabled={!inPeriod} ref={el=>fathername.current=el}/> <br /><br />




<input type='radio' checked={mc.fatherstatus=='alive'} onChange={()=> mce({'fatherstatus':'alive'})} name='fatherstatus' />
<span style={{...eng}}>Alive  </span>
<span style={{...tc}}>存  </span>
<span style={{...sc}}>存  </span>
&nbsp;
<input type='radio' checked={mc.fatherstatus=='deceased'} onChange={()=> mce({'fatherstatus':'deceased'})} name='fatherstatus'  />
<span style={{...eng}}>Deceased </span>
<span style={{...tc}}>歿 </span>
<span style={{...sc}}>歿 </span>

<br /><br />
<span className='smalltitle'>
<span style={{...eng}}>Residential Address </span>
<span style={{...tc}}>居住地址 </span>
<span style={{...sc}}>居住地址 </span>
</span><br />
<input type='text'ref={el=>fatheraddr.current=el}/> <br /><br />



<span className='smalltitle'>
<span style={{...eng}}>Contact No. </span>
<span style={{...tc}}>聯絡電話 </span>
<span style={{...sc}}>联络电话 </span>
</span>
<br />
<input type='text' disabled={!inPeriod} ref={el=>fathertel.current=el}/> <br /><br />



<span className='smalltitle'>
<span style={{...eng}}>Mother's Name </span>
<span style={{...tc}}>母親姓名 </span>
<span style={{...sc}}>母亲姓名 </span>
</span><br />
<input type='text' disabled={!inPeriod} ref={el=>mothername.current=el}/> <br /><br />

<input type='radio' checked={mc.motherstatus=='alive'} onChange={()=> mce({'motherstatus':'alive'})} name='motherstatus' />
<span style={{...eng}}>Alive  </span>
<span style={{...tc}}>存  </span>
<span style={{...sc}}>存  </span>
&nbsp;
<input type='radio' checked={mc.motherstatus=='deceased'} onChange={()=> mce({'motherstatus':'deceased'})} name='motherstatus'  /> 
<span style={{...eng}}>Deceased  </span>
<span style={{...tc}}>歿 </span>
<span style={{...sc}}>歿 </span>
<br /><br />
<span className='smalltitle'>
<span style={{...eng}}>Residential Address </span>
<span style={{...tc}}>居住地址 </span>
<span style={{...sc}}>居住地址 </span>
</span><br />
<input type='text' ref={el=>motheraddr.current=el} /> <br /><br />


<span className='smalltitle'>
<span style={{...eng}}>Contact No. </span>
<span style={{...tc}}>聯絡電話 </span>
<span style={{...sc}}>联络电话 </span>
</span>
<br />
<input type='text' disabled={!inPeriod} ref={el=>mothertel.current=el} /> <br /><br />

<span className='smalltitle'>
<span style={{...eng}}>Guardian's Name (if applicable) </span>
<span style={{...tc}}>監護人姓名(若適用) </span>
<span style={{...sc}}>监护人姓名(若适用) </span>
</span><br />
<input type='text' disabled={!inPeriod} ref={el=>guardianname.current=el}  /> <br /><br />


<span className='smalltitle'>
<span style={{...eng}}>Relation with applicant </span>
<span style={{...tc}}>與申請人之關係 </span>
<span style={{...sc}}>与申请人之关系 </span>
</span><br />
<input type='text' disabled={!inPeriod} ref={el=>guardianrel.current=el}  /> <br /><br />

<span className='smalltitle'>
<span style={{...eng}}>Contact No. </span>
<span style={{...tc}}>聯絡電話 </span>
<span style={{...sc}}>联络电话 </span>
</span><br />
<input type='text' disabled={!inPeriod} ref={el=>guardiantel.current=el}   />

<br /><br />
<span className='smalltitle'>5. 
<span style={{...eng}}> Hostel Information  </span>
<span style={{...tc}}> 宿舍資料 </span>
<span style={{...sc}}> 宿舍资料 </span>
</span><br /><br />

<span className='smalltitle'>5.1 
<span style={{...eng}}> Hostel Preference (from 1 to 6) </span>
<span style={{...tc}}> 申請人志願(請依次序填上1、2、3、4、5、6)  </span>
<span style={{...sc}}> 申请人志愿(请依次序填上1、2、3、4、5、6)   </span>
<Star /> </span>


<div style={{maxWidth:"600px",flexDirection:"row",display:'flex'}}>
	<div style={{width:"50%"}} >	
	&nbsp;
	</div>
	<div className='multiplechoice'> 
		1
	</div>
	<div className='multiplechoice'> 
		2
	</div>
	<div className='multiplechoice'> 
		3
	</div>
	<div className='multiplechoice'> 
		4
	</div>
	<div className='multiplechoice'> 
		5
	</div>
	<div className='multiplechoice'> 
		6
	</div>
</div>

<div style={{borderTop:"1px solid #C0C0C0",maxWidth:"600px",flexDirection:"row",display:'flex'}}>
	<div style={{width:"50%"}} >
	<span style={{...eng}}>Chih Hsing Hall (M)  </span>
	<span style={{...tc}}>知行樓 (男宿) </span>
	<span style={{...sc}}>知行楼 (男女宿) </span>
	<br />
	</div>
	<div className='multiplechoice'> 
		<input type='radio' disabled={!inPeriod}  checked={mc.hostel_c=='1'} onChange={()=> mce({'hostel_c':'1'})} name='hostel_c' />
	</div>
	<div  className='multiplechoice'> 
		<input type='radio'  disabled={!inPeriod} checked={mc.hostel_c=='2'} onChange={()=> mce({'hostel_c':'2'})} name='hostel_c'/>
	</div>
	<div  className='multiplechoice'> 
		<input type='radio'  disabled={!inPeriod} checked={mc.hostel_c=='3'} onChange={()=> mce({'hostel_c':'3'})} name='hostel_c'/>
	</div>
	<div  className='multiplechoice'> 
		<input type='radio'  disabled={!inPeriod} checked={mc.hostel_c=='4'} onChange={()=> mce({'hostel_c':'4'})} name='hostel_c'/>
	</div>
	<div  className='multiplechoice'> 
		<input type='radio'  disabled={!inPeriod} checked={mc.hostel_c=='5'} onChange={()=> mce({'hostel_c':'5'})} name='hostel_c'/>
	</div>
	<div  className='multiplechoice'> 
		<input type='radio' disabled={!inPeriod}  checked={mc.hostel_c=='6'} onChange={()=> mce({'hostel_c':'6'})} name='hostel_c'/>
	</div>
</div>


<div style={{borderTop:"1px solid #C0C0C0",maxWidth:"600px",flexDirection:"row",display:'flex'}}>
	<div style={{width:"50%"}} >
	<span style={{...eng}}>Xuesi Hall (F) </span>
	<span style={{...tc}}>學思樓(女宿) </span>
	<span style={{...sc}}>学思楼(女宿) </span>
	<br />

	</div>
	<div className='multiplechoice'> 
		<input type='radio' disabled={!inPeriod}  checked={mc.hostel_x=='1'} onChange={()=> mce({'hostel_x':'1'})} name='hostel_x'/>
	</div>
	<div className='multiplechoice'> 
		<input type='radio' disabled={!inPeriod}  checked={mc.hostel_x=='2'} onChange={()=> mce({'hostel_x':'2'})} name='hostel_x'/>
	</div>
	<div className='multiplechoice'> 
		<input type='radio' disabled={!inPeriod}  checked={mc.hostel_x=='3'} onChange={()=> mce({'hostel_x':'3'})} name='hostel_x'/>
	</div>
	<div className='multiplechoice'> 
		<input type='radio' disabled={!inPeriod}  checked={mc.hostel_x=='4'} onChange={()=> mce({'hostel_x':'4'})} name='hostel_x'/>
	</div>
	<div className='multiplechoice'> 
		<input type='radio'  disabled={!inPeriod} checked={mc.hostel_x=='5'} onChange={()=> mce({'hostel_x':'5'})} name='hostel_x'/>
	</div>
	<div className='multiplechoice'> 
		<input type='radio'  disabled={!inPeriod} checked={mc.hostel_x=='6'} onChange={()=> mce({'hostel_x':'6'})} name='hostel_x'/>
	</div>
</div>
	

<div style={{borderTop:"1px solid #C0C0C0",maxWidth:"600px",flexDirection:"row",display:'flex'}}>
	<div  style={{width:"50%"}} >
	<span style={{...eng}}>Daisy Li Hall (M & F) </span>
	<span style={{...tc}}>紫霞樓 (男女宿) </span>
	<span style={{...sc}}>紫霞楼 (男女宿)  </span>
	<br />
	</div>
	<div  className='multiplechoice'> 
		<input type='radio' disabled={!inPeriod} checked={mc.hostel_d=='1'} onChange={()=> mce({'hostel_d':'1'})} name='hostel_d'/>
	</div>
	<div  className='multiplechoice'> 
		<input type='radio' disabled={!inPeriod} checked={mc.hostel_d=='2'} onChange={()=> mce({'hostel_d':'2'})} name='hostel_d'/>
	</div>
	<div  className='multiplechoice'> 
		<input type='radio'disabled={!inPeriod}  checked={mc.hostel_d=='3'} onChange={()=> mce({'hostel_d':'3'})} name='hostel_d'/>
	</div>
	<div  className='multiplechoice'> 
		<input type='radio' disabled={!inPeriod} checked={mc.hostel_d=='4'} onChange={()=> mce({'hostel_d':'4'})} name='hostel_d'/>
	</div>
	<div  className='multiplechoice'> 
		<input type='radio' disabled={!inPeriod} checked={mc.hostel_d=='5'} onChange={()=> mce({'hostel_d':'5'})} name='hostel_d'/>
	</div>	
	<div  className='multiplechoice'> 
		<input type='radio' disabled={!inPeriod} checked={mc.hostel_d=='6'} onChange={()=> mce({'hostel_d':'6'})} name='hostel_d'/>
	</div>
</div>

<div style={{borderTop:"1px solid #C0C0C0",maxWidth:"600px",flexDirection:"row",display:'flex'}}>
	<div style={{width:"50%"}} >
	<span style={{...eng}}>Grace Tien Hall (M & F) </span>
	<span style={{...tc}}>志文樓 (男女宿) </span>
	<span style={{...sc}}>志文楼 (男女宿) </span>
	<br />

	</div>
	<div className='multiplechoice'> 
		<input type='radio' disabled={!inPeriod}  checked={mc.hostel_g=='1'} onChange={()=> mce({'hostel_g':'1'})} name='hostel_g'/>
	</div>
	<div className='multiplechoice'> 
		<input type='radio' disabled={!inPeriod}  checked={mc.hostel_g=='2'} onChange={()=> mce({'hostel_g':'2'})} name='hostel_g'/>
	</div>
	<div className='multiplechoice'> 
		<input type='radio'  disabled={!inPeriod} checked={mc.hostel_g=='3'} onChange={()=> mce({'hostel_g':'3'})} name='hostel_g'/>
	</div>
	<div className='multiplechoice'> 
		<input type='radio'  disabled={!inPeriod} checked={mc.hostel_g=='4'} onChange={()=> mce({'hostel_g':'4'})} name='hostel_g'/>
	</div>
	<div className='multiplechoice'> 
		<input type='radio' disabled={!inPeriod}  checked={mc.hostel_g=='5'} onChange={()=> mce({'hostel_g':'5'})} name='hostel_g'/>
	</div>
	<div className='multiplechoice'> 
		<input type='radio' disabled={!inPeriod}  checked={mc.hostel_g=='6'} onChange={()=> mce({'hostel_g':'6'})} name='hostel_g'/>
	</div>
</div>




<div style={{borderTop:"1px solid #C0C0C0",maxWidth:"600px",flexDirection:"row",display:'flex'}}>
	<div style={{width:"50%"}} >
	<span style={{...eng}}>Mei Yun Tang (M & F) </span>
	<span style={{...tc}}>梅雲堂 (男女宿) </span>
	<span style={{...sc}}>梅雲堂 (男女宿) </span>
	<br />

	</div>
	<div className='multiplechoice'> 
		<input type='radio'  disabled={!inPeriod} checked={mc.hostel_m=='1'} onChange={()=> mce({'hostel_m':'1'})} name='hostel_m'/>
	</div>
	<div className='multiplechoice'> 
		<input type='radio'  disabled={!inPeriod} checked={mc.hostel_m=='2'} onChange={()=> mce({'hostel_m':'2'})} name='hostel_m'/>
	</div>
	<div className='multiplechoice'> 
		<input type='radio'  disabled={!inPeriod} checked={mc.hostel_m=='3'} onChange={()=> mce({'hostel_m':'3'})} name='hostel_m'/>
	</div>
	<div className='multiplechoice'> 
		<input type='radio' disabled={!inPeriod}  checked={mc.hostel_m=='4'} onChange={()=> mce({'hostel_m':'4'})} name='hostel_m'/>
	</div>
	<div className='multiplechoice'> 
		<input type='radio'  disabled={!inPeriod} checked={mc.hostel_m=='5'} onChange={()=> mce({'hostel_m':'5'})} name='hostel_m'/>
	</div>
	<div className='multiplechoice'> 
		<input type='radio'  disabled={!inPeriod} checked={mc.hostel_m=='6'} onChange={()=> mce({'hostel_m':'6'})} name='hostel_m'/>
	</div>
</div>




	<div style={{borderTop:"1px solid #C0C0C0",maxWidth:"600px",flexDirection:"row",display:'flex'}}>
		<div style={{width:"50%"}} >
		<span style={{...eng}}>I-House (M & F)  </span>
		<span style={{...tc}}>國際生舍堂 (男女宿) </span>
		<span style={{...sc}}>国际生舍堂 (男女宿) </span>
		<br />
		</div>
		<div className='multiplechoice'> 
			<input type='radio' disabled={!inPeriod}  checked={mc.hostel_i=='1'} onChange={()=> mce({'hostel_i':'1'})} name='hostel_i'/>
		</div>
		<div className='multiplechoice'> 
			<input type='radio'  disabled={!inPeriod} checked={mc.hostel_i=='2'} onChange={()=> mce({'hostel_i':'2'})} name='hostel_i'/>
		</div>
		<div className='multiplechoice'> 
			<input type='radio' disabled={!inPeriod}  checked={mc.hostel_i=='3'} onChange={()=> mce({'hostel_i':'3'})} name='hostel_i'/>
		</div>
		<div className='multiplechoice'> 
			<input type='radio'  disabled={!inPeriod} checked={mc.hostel_i=='4'} onChange={()=> mce({'hostel_i':'4'})} name='hostel_i'/>
		</div>
		<div className='multiplechoice'> 
			<input type='radio'  disabled={!inPeriod} checked={mc.hostel_i=='5'} onChange={()=> mce({'hostel_i':'5'})} name='hostel_i'/>
		</div>
		<div className='multiplechoice'> 
			<input type='radio'  disabled={!inPeriod} checked={mc.hostel_i=='6'} onChange={()=> mce({'hostel_i':'6'})} name='hostel_i'/>
		</div>
	</div>
	
	<br />
	
	<span className='smalltitle'> 5.2 
	<span style={{...eng}}> Room Preference (from 1 to 3) </span>
	<span style={{...tc}}> 房間類型志願 (請依次序填上 1、2、3) </span>
	<span style={{...sc}}> 房间类型志愿 (请依次序填上 1、2、3) </span>
	<Star /></span>
	<br />
	
	
	<div style={{maxWidth:"600px",flexDirection:"row",display:'flex'}}>
		<div style={{width:"70%"}} >
		<span className='smalltitle'>&nbsp;</span>
		</div>
		<div className='multiplechoice'> 
			1
		</div>
		<div className='multiplechoice'> 
			2
		</div>
		<div className='multiplechoice'> 
			3
		</div>
		
	</div>
	
	
	<div style={{borderTop:"1px solid #C0C0C0",maxWidth:"600px",flexDirection:"row",display:'flex'}}>
		<div style={{width:"70%"}} >
		<span className='smalltitle'>
		<span style={{...eng}}>Double Room </span>
		<span style={{...tc}}>二人房 </span>
		<span style={{...sc}}>二人房 </span>
		</span>
		</div>
		<div className='multiplechoice'> 
			<input type='radio'  disabled={!inPeriod} checked={mc.room_2=='1'} onChange={()=> mce({'room_2':'1'})} name='room_2'/>
		</div>
		<div className='multiplechoice'> 
			<input type='radio'  disabled={!inPeriod} checked={mc.room_2=='2'} onChange={()=> mce({'room_2':'2'})} name='room_2' />
		</div>
		<div className='multiplechoice'> 
			<input type='radio'  disabled={!inPeriod} checked={mc.room_2=='3'} onChange={()=> mce({'room_2':'3'})} name='room_2' />
		</div>
		
	</div>
	
	
	<div style={{borderTop:"1px solid #C0C0C0",maxWidth:"600px",flexDirection:"row",display:'flex'}}>
		<div style={{width:"70%"}} >
		<span className='smalltitle'>
		<span style={{...eng}}>Triple Room </span>
		<span style={{...tc}}>三人房 </span>
		<span style={{...sc}}>三人房 </span>
		</span>
		</div>
		<div className='multiplechoice'> 
			<input type='radio'  disabled={!inPeriod}  checked={mc.room_3=='1'} onChange={()=> mce({'room_3':'1'})} name='room_3'  />
		</div>
		<div className='multiplechoice'> 
			<input type='radio'  disabled={!inPeriod}  checked={mc.room_3=='2'} onChange={()=> mce({'room_3':'2'})} name='room_3' />
		</div>
		<div className='multiplechoice'> 
			<input type='radio'  disabled={!inPeriod}  checked={mc.room_3=='3'} onChange={()=> mce({'room_3':'3'})} name='room_3' />
		</div>
		
	</div>
	
	<div style={{borderTop:"1px solid #C0C0C0",maxWidth:"600px",flexDirection:"row",display:'flex'}}>
		<div style={{width:"70%"}} >
		<span className='smalltitle'>
		<span style={{...eng}}>Converted Triple Room </span>
		<span style={{...tc}}>改裝三人房 </span>
		<span style={{...sc}}>改装三人房 </span>
		</span>
		</div>
		<div className='multiplechoice'> 
			<input type='radio' disabled={!inPeriod}  checked={mc.room_3c=='1'} onChange={()=> mce({'room_3c':'1'})} name='room_3c'/>
		</div>
		<div className='multiplechoice'> 
			<input type='radio'  disabled={!inPeriod} checked={mc.room_3c=='2'} onChange={()=> mce({'room_3c':'2'})} name='room_3c'/>
		</div>
		<div className='multiplechoice'> 
			<input type='radio'  disabled={!inPeriod} checked={mc.room_3c=='3'} onChange={()=> mce({'room_3c':'3'})} name='room_3c' />
		</div>
		
	</div>
	
	
	<br />
	<span className='smalltitle'>6. 
	<span style={{...eng}}> Additional Information (For Exceptional Circumstances) </span> 
	<span style={{...tc}}> 附加資料(特殊情況)	 </span>
	<span style={{...sc}}> 附加资料(特殊情况)	 </span>
	<br /><br />
	
	<span className='smalltitle' style={{...eng}}>Please select </span>
	<span className='smalltitle' style={{...tc}}>請選擇 </span>
	<span className='smalltitle' style={{...sc}}>请选择 </span>
	<br />
		
	<div className='f-r'>
		<div><input type='checkbox'  disabled={!inPeriod} checked={mc.health=='yes'} onChange={()=> mce({'health':mc.health=='yes'?'':'yes'})} name='health' /> </div>
		<div>
		<span style={{...eng}}>Health (Please produce written certification by doctors from the University Health Service.)  </span>
		<span style={{...tc}}>健康 (需具大學保健處醫生書面証明) </span>
		<span style={{...sc}}>健康 (需具大学保健处医生书面证明) </span>
		
		</div>
	</div>
	
	<div className='f-r'>
		<div><input type='checkbox'  disabled={!inPeriod} checked={mc.family=='yes'} onChange={()=> mce({'family':mc.family=='yes'?'':'yes'})} name='family' /> </div>
		<div style={{...eng}}>Family (Please produce written certification by social workers or related professionals.) </div>
		<div style={{...tc}}>家庭 (需具社工/其它有關專業人士書面証明)</div>
		<div style={{...sc}}>家庭 (需具社工/其它有关专业人士书面证明)</div>
	</div>
	
	<br />Supporting document<br />
	
	<Upload filter={['familyhealth']} />
	
	<br />
	
	
	<span className='smalltitle'>
	
	{/*
	<span style={{...eng}}> Additional Information (For Exceptional Circumstances)</span> 
	<span style={{...tc}}> 附加資料(特殊情況)	 </span>
	<span style={{...sc}}> 附加资料(特殊情況)	 </span>
	<br /><br />
	*/}
	<hr />
	
	7 &nbsp;
	<span style={{...eng}}> Application for Residence at A Specific Student Hostel (if applicable)  </span>		
	<span style={{...tc}}> 申請入住指定宿舍(若適用) </span>
	<span style={{...sc}}> 申请入住指定宿舍(若适用) </span>	
	<br /><br />
	
	<span className='smalltitle' style={{...eng}}>
	To help residents develop a sense of belonging to their hostels, the College hasintroduced a scheme - "The Application for Residence at a A Specific Hostel".Residents can apply for residing at the same hostel in {year} . Wardensmay send their recommendations to the Committee on Student Hostelsaccording to the applicants' commitment and contributions to the specifichostels. The number of recommended applicants should not exceed a tenthpercent of the total number of residents of the hostels.		
	</span>	
	<span className='smalltitle' style={{...tc}}>增設此項申請為鼓勵同學對個別宿舍的歸屬感。宿生可申請於 {year} 學年繼續居於本學年分派的宿舍。各宿舍主任可因應申請人對宿舍群體生活表現或貢獻，向學生宿舍委員會推薦。推薦宿位總數最多為個別宿舍宿位總數百分之十。</span>
	<span className='smalltitle' style={{...sc}}>增设此项申请为鼓励同学对个别宿舍的归属感。宿生可申请于 {year} 学年继续居于本学年分派的宿舍。各宿舍主任可因应申请人对宿舍群体生活表现或贡献，向学生宿舍委员会推荐。推荐宿位总数最多为个别宿舍宿位总数百分之十。 </span>
	<br />
	</span>
	
	<br />
	
	<span className='smalltitle' style={{...eng}}>
	I would like to apply for residence at a specific student hostel.
	</span>	
	<span className='smalltitle' style={{...tc}}>本人有意申請入住指定宿舍。</span>
	<span className='smalltitle' style={{...sc}}>本人有意申請入住指定宿舍。</span>
	<br />

	<input type='checkbox'  disabled={!inPeriod} checked={mc.want=='yes'} onChange={()=> mce({'want':mc.want=='yes'?'':'yes'})} name='want'  />  
	<span style={{...eng}}>Yes</span>
	<span style={{...tc}}>是</span>
	<span style={{...sc}}>是</span>
	
	<br /><br />
	
	
	7.1 &nbsp;
	<span style={{...eng}}> Specific Hostel  </span>		
	<span style={{...tc}}> 申請入住宿舍 </span>
	<span style={{...sc}}> 申请入住宿舍 </span>	
	<br />
	
	<div >
		<input type='radio' disabled={!inPeriod}  checked={mc.wanthostel=='Chih Hsing Hall(M)'} 
				onChange={()=> mce({'wanthostel':'Chih Hsing Hall(M)'})} name='wanthostel' />		
		<span style={{...eng}}>Chih Hsing Hall(M)</span>		
		<span style={{...tc}}>知行樓 (男宿)　</span>
		<span style={{...sc}}>知行楼 (男宿)　</span>		
	</div>
	
	<div >
		<input type='radio' disabled={!inPeriod} checked={mc.wanthostel=='Xuesi Hall (F)'} 
					onChange={()=> mce({'wanthostel':'Xuesi Hall (F)'})} name='wanthostel'/>
		<span style={{...eng}}>Xuesi Hall (F)</span>		
		<span style={{...tc}}>學思樓 (女宿)　</span>
		<span style={{...sc}}>學思楼 (女宿)　</span>
	</div>
	
	<div>
		<input type='radio' disabled={!inPeriod} checked={mc.wanthostel=='Grace Tien Hall (M & F)'} 
				onChange={()=> mce({'wanthostel':'Grace Tien Hall (M & F)'})} name='wanthostel'/>
		<span style={{...eng}}>Grace Tien Hall (M & F)</span>		
		<span style={{...tc}}>志文樓 (男女宿)</span>
		<span style={{...sc}}>志文楼 (男女宿)</span>
	</div>           
	
	<div >
		<input type='radio'  disabled={!inPeriod} checked={mc.wanthostel=='Daisy Li Hall (M & F)'} 
			onChange={()=> mce({'wanthostel':'Daisy Li Hall (M & F)'})} name='wanthostel'/>
		<span style={{...eng}}>Daisy Li Hall (M & F)</span>		
		<span style={{...tc}}>紫霞樓 (男女宿)</span>
		<span style={{...sc}}>紫霞楼 (男女宿)</span>
	</div>
	<br />
	
	7.2 &nbsp; 
	<span style={{...eng}}>Record of Residence (Hostel/Year) </span>		
	<span style={{...tc}}>住宿紀錄 (宿舍/學年)</span>
	<span style={{...sc}}>住宿紀錄 (宿舍/學年)</span>	
	<br />
	
	<input type='text' disabled={!inPeriod} ref={el=>wantrecord.current=el} /><br />
	
	<br /><br />
	7.3 <span style={{...eng}}>Reason for Application</span>		
	<span style={{...tc}}>申請理由</span>
	<span style={{...sc}}>申請理由</span>		 
	<br />
	<textarea type='text' rows="5" cols="50" disabled={!inPeriod} ref={el=>wantreason.current=el} />
	
	<br />
	
	<br /><br />
	
	7.4 &nbsp; 
	<span style={{...eng}}>Supporting Documents (if applicable) </span>		
	<span style={{...tc}}>證明文件 (若適用)</span>
	<span style={{...sc}}>证明文件 (若适用)</span>	
	
	
	<Upload filter={["want"]} />
		
	<br /><br />
	
	<span className='smalltitle'>8. 
	
	<span style={{...eng}}> Declaration </span>
	<span style={{...tc}}> 聲明</span>
	<span style={{...sc}}> 声明</span>
	
	<br />
<span style={{...eng}}>	
<br />Declaration by Parents (Father/Mother/Guardian): 
<br />I have read and fully understood the New Asia College Student Hostel Regulations. I hereby undertake to guarantee that the applicant will comply with the Hostel Regulations during his/her residence if he/she is allocated a hostel place. I also undertake to bear any financial responsibilities incurred by unsettled hostel fees or damage to or defacement of any hostel property.
 </span>

<span style={{...tc}}>
<br />申請人家長(父/母/監護人)聲明：
<br />本人已細閱及明白「新亞書院學生宿舍章則」，並完全明白其內容。現特此聲明，如申請人獲配宿位,本人願意保証申請人在住宿期間，遵守宿舍章則。 如損壞公物或欠繳宿費，本人願意負責償還。 <Star /></span>
</span>


<span style={{...sc}}>
<br />申请人家长(父\母\监护人)声明：
<br />本人已细阅及明白「新亚书院学生宿舍章则」，并完全明白其内容。现特此声明，如申请人获配宿位,本人愿意保证申请人在住宿期间，遵守宿舍章则。 如损坏公物或欠缴宿费，本人愿意负责偿还。 <Star /></span>
</span>

	
	
	<br />
	
	<input type='checkbox' disabled={!inPeriod} checked={mc.declaration1=='yes'} onChange={()=> mce({'declaration1':mc.declaration1=='yes'?'':'yes'})} name='declaration1'  />  
	<span style={{...eng}}>Yes</span>
	<span style={{...tc}}>是</span>
	<span style={{...sc}}>是</span>
	
	<br />
	
<span className='smalltitle'>

<span style={{...eng}}>
Declaration by Student: 
<br />I have read and fully understood the New Asia College Student Hostel Selection Criteria, and the New Asia College Student Hostel Regulations. I hereby undertake to observe the Hostel Regulations should my application for hostel residence be approved.
 </span>
 
<span style={{...tc}}>
<br />申請人聲明：
<br />本人已細閱「新亞書院學生宿舍遴選標準及細則」及「新亞書院學生宿舍章則」，並完全明白其內容。 <Star /></span>
 </span>
 
<span style={{...sc}}>
<br />申请人声明：
<br />本人已细阅「新亚书院学生宿舍遴选标准及细则」及「新亚书院学生宿舍章则」，并完全明白其内容。 <Star /></span>
 </span>

	<br />
	<input type='checkbox'  disabled={!inPeriod} checked={mc.declaration2=='yes'} onChange={()=> mce({'declaration2':mc.declaration2=='yes'?'':'yes'})} name='declaration2'  />  
		<span style={{...eng}}>Yes</span>
		<span style={{...tc}}>是</span>
		<span style={{...sc}}>是</span>
	
	<br /><br />
	
	
	<span className='smalltitle'>
	<span style={{...eng}}>
	I delclare that all the information provided in this application is complete and true. I undertake to accept any penalties and criminal liabilities for any false statement in the application.
	</span> </span>
	
	<span className='smalltitle'>
	<span style={{...tc}}>
	本人聲明，於本申請書所填報之各項資料，均屬確實無訛。若有虛報者，將接受處分，並須承擔個人刑事責任。
	</span> </span>
	
	<span className='smalltitle'>
	<span style={{...sc}}>
	本人声明，于本申请书所填报之各项资料，均属确实无讹。若有虚报者，将接受处分，并须承担个人刑事责任。	
	</span> </span>
	
	<Star /> 
	<br />
	<input type='checkbox' disabled={!inPeriod} checked={mc.declaration3=='yes'} onChange={()=> mce({'declaration3':mc.declaration3=='yes'?'':'yes'})} name='declaration3'  />  
	
	<span style={{...eng}}>Yes</span>
	<span style={{...tc}}>是</span>
	<span style={{...sc}}>是</span>

	
	<br /><br />
	
	<span className='smalltitle'>
	<span style={{...eng}}>
	I give my consent to the Committee on Student Hostels of New Asia College toconduct home visits and any other legal and reasonable means necessary toverify the information provided in this application to determine my eligibilityfor hostel placement. I understand that my hostel application may not beprocessed should I fail to cooperate fully.
	</span> </span>
	
	<span className='smalltitle'>
	<span style={{...tc}}>
	本人同意新亞書院學生宿舍委員會根據本人所提供之資料，以家訪等合法、合理之方法，審定本人是否合乎資格獲配宿位。如本人無法配合書院審核工作，本人明白書院有權對本人之宿舍申請不作處理。
	</span> </span>
	
	<span className='smalltitle'>
	<span style={{...sc}}>
	本人同意新亚书院学生宿舍委员会根据本人所提供之资料，以家访等合法、合理之方法，审定本人是否合乎资格获配宿位。如本人无法配合书院审核工作，本人明白书院有权对本人之宿舍申请不作处理。
	</span> </span>
	
	<Star /> 
	<br />
	<input type='checkbox'  disabled={!inPeriod} checked={mc.declaration4=='yes'} onChange={()=> mce({'declaration4':mc.declaration4=='yes'?'':'yes'})} name='declaration4'  />  
	
	<span style={{...eng}}>Yes</span>
	<span style={{...tc}}>是</span>
	<span style={{...sc}}>是</span>

	
	
	
	
	
	
	
	


	
	
	
	
	
	
	

	<br />
	
{/* 
	<span style={{...eng}}>
Please be reminded that this application form should be submitted with the following documents:
	
<br /><br />a. Proof of Residential Address (Maybe required to provide original copy for verification)<Star />
	
	<br /><br />
i) Copy of the Tenancy Agreement with parents' names issued by Hong Kong Housing Authority/ Hong Kong HousingSociety;
<br />
ii) Copies of the latest Rental Agreement with parents' names and the latest Rating and Value Demand for Rates andGovernment Rent for private housing;
<br />
iii) Copies of the latest Rental Agreement and the latest Rating and Value Demand for Rates and Government Rent for multi-tenancy of private housing;
<br />
iv) With the exception of sibling, non-lineal relatives staying with the applicants should submit a written self-declarationsigned by both the student applicant and tenant.
<br /><br />
b. Area Testimonial
<br /><br />
c. Resident Registration Form
<br /><br />
d. Application for an Exchange Student Room-mate (if applicable)
<br /><br />
e. Application for a Non-local Student Room-mate (if applicable)<br />
Please present original copy for checking for the Item (a)
<br /><br />
f. Application for Residence at A Specific Student Hostel (if applicable)
<br /><br />
g. Proof of Green Walk (if applicable)
<br /><br />
h. Google Map Screen Capture (District Point) (if applicable)
</span>


<span style={{...tc}}>
請勿忘記將下列文件與申請書一併遞交：<br /><br />
<Star />(一) 住址証明文件(有需要時須提供正本核實。)<br />

<br />
i) 香港房屋委員會或香港房屋協會轄下的公共房屋需具有父/母姓名之公屋住戶証副本<br />
ii) 租住私人樓宇需提供近期具有父/母姓名租約及差餉單之副本<br />
iii) 分租戶需具租約，近期租單及差餉單之副本<br />
iv) 除直系親屬(兄弟姊妹)外，如有其他親友同住，需提交具申請者及居住單位戶主的簽名聲明<br /><br />
(二) 面積證明<br /><br />
(三) 宿生登記表<br /><br />
(四) 申請與交換生為房友(若適用)<br /><br />
(五) 申請與非本地本科生為房友(若適用)<br /><br />
(六) 申請入住指定宿舍(若適用) <br /><br />
(七) 大步行參加者證明(若適用) <br /><br />
(八) 谷歌地圖擷圖(計算地區分)(若適用)
 </span>

 

 <span style={{...sc}}>
请勿忘记将下列文件与申请书一并递交：<br /><br />
<Star />(一) 住址证明文件(有需要时须提供正本核实。)<br />

<br />
i) 香港房屋委员会或香港房屋协会辖下的公共房屋需具有父/母姓名之公屋住户证副本<br />
ii) 租住私人楼宇需提供近期具有父/母姓名租约及差饷单之副本<br />
iii) 分租户需具租约，近期租单及差饷单之副本<br />
iv) 除直系亲属(兄弟姊妹)外，如有其他亲友同住，需提交具申请者及居住单位户主的签名声明<br /><br />
(二) 面积证明<br /><br />
(三) 宿生登记表<br /><br />
(四) 申请与交换生为房友(若适用)<br /><br />
(五) 申请与非本地本科生为房友(若适用)<br /><br />
(六) 申请入住指定宿舍(若适用) <br /><br />
(七) 大步行参加者证明(若适用) <br /><br />
(八) 谷歌地图撷图(计算地区分)(若适用) <br /><br />
 </span>
*/}

<br /><br />
<input type='button' onClick={ ()=> validate() }  value={(lang=='eng'?"Save and Submit":'') + (lang=='tc'?"儲存及提交":'') + (lang=='sc'?"储存及提交":'')} /> &nbsp;&nbsp;&nbsp;
<input type='button' onClick={ ()=> logout() }  value={(lang=='eng'?"Logout":'') + (lang=='tc'?"登出":'') + (lang=='sc'?"登出":'')} />



<br /><br />
	
	Disclaimer <br />
	The personal data collected will be used by New Asia College (NA) and authorised personnel for processing the captioned purposes in accordance with relevant provisions of the Personal Data (Privacy) Ordinance.
	<br /><br /><br />
    </div>
	
	</Context.Provider>
  );
}

export default App;
